import React from 'react';
import { Link } from 'react-router-dom';

export interface LinkCellProps {
  /** The text to display */
  children: React.ReactNode;
  /** The route to navigate to */
  to: string;
  /** Additional CSS classes */
  className?: string;
  /** Whether the link is disabled */
  disabled?: boolean;
}

export const LinkCell: React.FC<LinkCellProps> = ({
  children,
  to,
  className = '',
  disabled = false,
}) => {
  if (disabled) {
    return <span className={`text-default-500 ${className}`}>{children}</span>;
  }

  return (
    <Link
      to={to}
      className={`text-primary hover:text-primary-600 hover:underline transition-colors duration-200 ${className}`}
    >
      {children}
    </Link>
  );
};
